import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import api from '../utils/api';
import "./Signup.css";

const Signup = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [message, setMessage] = useState("");
  const [isLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/pran/register", { username, password });
      setMessage("Signup successful! Please login.");
      navigate("/login");
    } catch (error) {
      setMessage(
        "Signup failed: " + (error.response?.data?.message || "Error")
      );
    }
  };
  return (
    <div className="hc-signup-container">
      <div className="hc-signup-bg">
        <div className="hc-signup-shape hc-shape-1"></div>
        <div className="hc-signup-shape hc-shape-2"></div>
        <div className="hc-signup-shape hc-shape-3"></div>
      </div>

      <div className="hc-signup-grid">
        <motion.section
          className="hc-signup-hero"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div className="hc-hero-overlay"></div>
          <div className="hc-hero-image"></div>
          <div className="hc-hero-gradient"></div>

          <motion.div
            className="hc-hero-content"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <div className="hc-hero-icon">
              <svg
                className="hc-heart-icon"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
              </svg>
            </div>
            <h1 className="hc-hero-title">Join HealthConnect</h1>
            <p className="hc-hero-subtitle">
              Start your journey with our comprehensive healthcare management
              platform.
            </p>

            <div className="hc-hero-features">
              <div className="hc-feature-item">
                <div className="hc-feature-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z" />
                  </svg>
                </div>
                <span>Secure</span>
              </div>
              <div className="hc-feature-item">
                <div className="hc-feature-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M16 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm4 18v-6h2.5l-2.54-7.63A1.999 1.999 0 0 0 18.06 7c-.8 0-1.54.5-1.84 1.25l-1.92 5.76c-.3.9.34 1.99 1.3 1.99H17v6h3zM12.5 11.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5S11 9.17 11 10s.67 1.5 1.5 1.5zM5.5 6c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2zm2.5 16v-6H10l-2.54-7.63A1.999 1.999 0 0 0 5.56 7c-.8 0-1.54.5-1.84 1.25L1.8 13.01c-.3.9.34 1.99 1.3 1.99H5v6h3z" />
                  </svg>
                </div>
                <span>Community</span>
              </div>
              <div className="hc-feature-item">
                <div className="hc-feature-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                  </svg>
                </div>
                <span>Caring</span>
              </div>
            </div>
          </motion.div>
        </motion.section>

        <motion.section
          className="hc-signup-form-section"
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div className="hc-form-container">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="hc-form-wrapper"
            >
              <div className="hc-form-header">
                <h2 className="hc-form-title">Create Account</h2>
                <p className="hc-form-subtitle">
                  Join us to access innovative healthcare solutions
                </p>
              </div>

              <div className="hc-form-card">
                <div className="hc-card-head">
                  <h3 className="hc-card-title">Sign Up</h3>
                  <p className="hc-card-desc">
                    Fill in your details to get started
                  </p>
                </div>

                <form onSubmit={handleSubmit} className="hc-form">
                  {/* Username */}
                  <div className="hc-form-group">
                    <label htmlFor="username" className="hc-label">
                      Username
                    </label>
                    <div className="hc-input-wrapper">
                      <svg
                        className="hc-input-icon"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                      </svg>
                      <input
                        type="text"
                        id="username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        className="hc-input"
                        placeholder="Choose a username"
                        required
                      />
                    </div>
                  </div>

                  {/* Password */}
                  <div className="hc-form-group">
                    <label htmlFor="password" className="hc-label">
                      Password
                    </label>
                    <div className="hc-input-wrapper">
                      <svg
                        className="hc-input-icon"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM12 17c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM15.1 8H8.9V6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2z" />
                      </svg>
                      <input
                        type={showPassword ? "text" : "password"}
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="hc-input"
                        placeholder="Create a password"
                        required
                      />
                      <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        className="hc-password-toggle"
                      >
                        {showPassword ? "🙈" : "👁️"}
                      </button>
                    </div>
                  </div>

                  {/* Confirm Password */}
                  <div className="hc-form-group">
                    <label htmlFor="confirmPassword" className="hc-label">
                      Confirm Password
                    </label>
                    <div className="hc-input-wrapper">
                      <svg
                        className="hc-input-icon"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                      </svg>
                      <input
                        type={showConfirmPassword ? "text" : "password"}
                        id="confirmPassword"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        className="hc-input"
                        placeholder="Confirm your password"
                        required
                      />
                      <button
                        type="button"
                        onClick={() =>
                          setShowConfirmPassword(!showConfirmPassword)
                        }
                        className="hc-password-toggle"
                      >
                        {showConfirmPassword ? "🙈" : "👁️"}
                      </button>
                    </div>
                  </div>

                  <button
                    type="submit"
                    className="hc-submit-btn"
                    disabled={isLoading}
                  >
                    {isLoading ? "Creating Account..." : "Create Account"}
                  </button>

                  {message && (
                    <p
                      className={`hc-message ${
                        message.includes("failed") ||
                        message.includes("don't match") ||
                        message.includes("must be")
                          ? "hc-error"
                          : "hc-success"
                      }`}
                    >
                      {message}
                    </p>
                  )}

                  <div className="hc-form-links">
                    <span>Already have an account?</span>
                    <Link to="/login" className="hc-login-link">
                      Sign in
                    </Link>
                  </div>
                </form>
              </div>

              <div className="hc-form-footer">
                <p>
                  By creating an account, you agree to our{" "}
                  <Link to="/terms" className="hc-footer-link">
                    Terms of Service
                  </Link>{" "}
                  and{" "}
                  <Link to="/privacy" className="hc-footer-link">
                    Privacy Policy
                  </Link>
                  .
                </p>
              </div>
            </motion.div>
          </div>
        </motion.section>
      </div>
    </div>
  );
};

export default Signup;
